var exports = {
  "kL": "xcc377c0b--62c22c--container",
  "OR": "xcc377c0b--62c22c--mainPriceText",
  "HP": "xcc377c0b--62c22c--mainPriceText-big",
  "MO": "xcc377c0b--62c22c--secondPrice",
};

module.exports = exports;
